module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/InglouriousBasterds.fdee44f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/InglouriousBasterds.jpg
// module id = xo7f
// module chunks = 0